import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../../Containers/Config/index.js';
import { GET_LEDGER_SUMMARY, GET_LEDGER_SUMMARY_SUCCESS, GET_LEDGER_SUMMARY_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';

function* getLedgerSummary({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ledger-summary`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_LEDGER_SUMMARY_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_LEDGER_SUMMARY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_LEDGER_SUMMARY_ERROR, payload: error });
  }
}

export function* watchgetLedgerSummary() {
  yield takeEvery(GET_LEDGER_SUMMARY, getLedgerSummary);
}

function* getLedgerSummarySaga() {
  yield all([fork(watchgetLedgerSummary)]);
}

export default getLedgerSummarySaga;
